import { FC, useCallback } from 'react';
import { Block } from '@ui-kit/Block';
import { BasketCartProductTypeProps } from './TypeProps';
import { fetchDeleteProductFromBasket, fetchUpdateProductInBasket } from '@entities/Basket';
import { getAllInfoProduct } from '@redux/slices/ProductManagement';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { InfoBlock } from '@entities/Basket/ui/BasketCartProduct/ui/InfoBlock';
import { ProductInfo, ProductPrice, ProductImage, ActionsBlock, ProductDeleteAndWishlist } from './ui';

import styles from './BasketCartProduct.module.scss';
import classNames from 'classnames';

type BasketCartProductProps = BasketCartProductTypeProps & {
  index: number;
};

export const BasketCartProduct: FC<BasketCartProductProps> = productProps => {
  const { index, ...props } = productProps;

  const dispatch = useAppDispatch();
  const { REGION: regionId } = useAppSelector(state => state.header.data.region);

  const handlerUpdateQuantity = useCallback(
    async quantity => {
      await dispatch(fetchUpdateProductInBasket({ productId: props?.id, qty: quantity, regionId: +regionId }));
    },
    [props?.id],
  );

  const handlerDeleteBasket = useCallback(async () => {
    await dispatch(fetchDeleteProductFromBasket({ productId: props?.id, regionId: +regionId }));
    await dispatch(getAllInfoProduct(+regionId));
  }, [props?.id]);

  return (
    <Block className={classNames(styles.Wrapper, { [styles.Info]: props?.enabled === false })} dataTestId={'product-basket-' + index}>
      {props?.enabled === false && !!props?.noEnabledError && <InfoBlock className={styles.InfoBlockGrid}>{props?.noEnabledError}</InfoBlock>}
      <ProductImage className={styles.Image} image={props?.image} url={props?.url || ''} name={props?.name} />
      <ProductInfo
        url={props?.url}
        name={props?.name}
        price={props?.price}
        specPrice={props?.specPrice}
        description={props?.description}
        className={styles.ProductInfo}
      />
      <ActionsBlock
        rn={props?.rn}
        part={props?.part}
        allQuantity={props?.allQuantity}
        actions={props?.actions}
        className={styles.ActionsBlock}
      />
      <ProductPrice
        price={props?.price}
        specPrice={props?.specPrice}
        allQuantity={props?.allQuantity}
        quantity={props?.quantity}
        className={styles.ProductPrice}
        part={props?.part}
        productId={props?.id}
        handlerUpdateQuantity={handlerUpdateQuantity}
      />
      <ProductDeleteAndWishlist
        part={props?.part}
        productId={props?.id}
        handlerDeleteBasket={handlerDeleteBasket}
        className={styles.ProductDeleteAndWishlist}
      />
    </Block>
  );
};
